/*!
 * referral-bar.js v1.0
 * Trafik kaynağına göre (Meta / Google / TikTok) sayfanın en tepesinde güven barı gösterir.
 *
 * Kullanım (header'dan ÖNCE, senkron):
 *   <script src="referral-bar.js"></script>
 *   <script>ReferralBar.init({ ...config... });</script>
 *
 * - Kaynak yoksa hiçbir şey basmaz (DOM'a bile girmez).
 * - sessionStorage ile oturum boyunca sabit kalır.
 * - X ile kapatılınca o oturum bir daha gösterilmez.
 * - Dinamik metin textContent ile basılır (XSS yok); innerHTML yalnızca sabit SVG için.
 * - QA: adrese ?rbar=meta / ?rbar=google / ?rbar=tiktok ekleyerek zorla test edilir.
 */
(function (w, d) {
  'use strict';
  if (w.ReferralBar) return;

  /* ---------------------------------------------------------------- ikonlar */
  var SVG = {
    instagram: '<svg viewBox="0 0 24 24" width="27" height="27" fill="none" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="rbarIg" x1="2" y1="22" x2="22" y2="2" gradientUnits="userSpaceOnUse"><stop stop-color="#FEDA75"/><stop offset=".35" stop-color="#FA7E1E"/><stop offset=".62" stop-color="#D62976"/><stop offset=".85" stop-color="#962FBF"/><stop offset="1" stop-color="#4F5BD5"/></linearGradient></defs><rect x="2.2" y="2.2" width="19.6" height="19.6" rx="6" stroke="url(#rbarIg)" stroke-width="2"/><circle cx="12" cy="12" r="4.6" stroke="url(#rbarIg)" stroke-width="2"/><circle cx="17.4" cy="6.6" r="1.4" fill="url(#rbarIg)"/></svg>',
    google: '<svg viewBox="0 0 48 48" width="25" height="25" xmlns="http://www.w3.org/2000/svg"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>',
    tiktok: '<svg viewBox="0 0 24 24" width="25" height="25" xmlns="http://www.w3.org/2000/svg"><path fill="#25F4EE" d="M9.4 9.6v3.05a3.2 3.2 0 0 0-1.02-.17 3.28 3.28 0 0 0 0 6.56c.3 0 .6-.04.88-.13a3.28 3.28 0 0 1-2.42-3.17 3.28 3.28 0 0 1 3.98-3.2V9.5a6.4 6.4 0 0 0-1.42-.05z"/><path fill="#FE2C55" d="M15.63 2h-1.5a5.1 5.1 0 0 0 3.9 4.66v2.5a6.9 6.9 0 0 1-1.5-.2v4.9a5.9 5.9 0 0 1-9.3 4.82 5.9 5.9 0 0 0 10.3-3.95V9.83a6.9 6.9 0 0 0 4 1.28V8.05a4.03 4.03 0 0 1-3.9-4.05V2z"/><path fill="#fff" d="M14.13 2v11.86a3.28 3.28 0 0 1-6.13 1.63 3.28 3.28 0 0 1 2.42-4.83V9.5A5.9 5.9 0 0 0 7.23 18.7a5.9 5.9 0 0 0 9.3-4.82v-4.9a6.9 6.9 0 0 0 4 1.28V8.05a4.03 4.03 0 0 1-3.9-4.05V2h-2.5z"/></svg>',
    close: '<svg width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 2L12 12M12 2L2 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
  };

  /* ------------------------------------------------------- kaynak kuralları */
  /* q   = location.search (küçük harf)
     ref = document.referrer (küçük harf)
     ua  = navigator.userAgent                                                */
  var RULES = {
    meta: function (q, ref, ua) {
      return q.indexOf('fbclid=') > -1 ||
        /utm_source=(instagram|ig|facebook|fb|meta)/.test(q) ||
        /(^|\.)(instagram|facebook)\.com/.test(ref) ||
        /l\.instagram\.com|lm?\.facebook\.com/.test(ref) ||
        /(FBAN|FBAV|FB_IAB|FB4A|Instagram|IGAB)/i.test(ua); /* uygulama içi tarayıcı */
    },
    google: function (q, ref, ua) {
      return q.indexOf('gclid=') > -1 ||
        q.indexOf('gbraid=') > -1 ||
        q.indexOf('wbraid=') > -1 ||
        q.indexOf('gclsrc=') > -1 ||
        q.indexOf('gad_source=') > -1 ||
        q.indexOf('gad_campaignid=') > -1 ||
        /utm_source=google/.test(q) ||
        /google\.[a-z]{2,}/.test(ref) ||          /* google.com, google.com.tr, news.google.com */
        /googleadservices|googlesyndication|doubleclick|googleusercontent/.test(ref) ||
        /android-app:\/\/com\.google\.android/.test(ref) || /* Android Google / Chrome uygulaması */
        /\bGSA\//.test(ua);                       /* iOS Google uygulaması */
    },
    tiktok: function (q, ref, ua) {
      return q.indexOf('ttclid=') > -1 ||
        /utm_source=(tiktok|tt)/.test(q) ||
        /(^|\.)tiktok\.com/.test(ref) ||
        /BytedanceWebview|musical_ly|Bytelo/i.test(ua);
    }
  };

  /* -------------------------------------------------------------- algılama */
  function compute(cfg) {
    var q = (location.search || '').toLowerCase(),
        ref = (d.referrer || '').toLowerCase(),
        ua = navigator.userAgent || '',
        forced = /[?&]rbar=([a-z0-9_-]+)/.exec(q);

    if (forced && cfg.variants[forced[1]]) return forced[1];

    var order = cfg.order || ['meta', 'google', 'tiktok'];
    for (var i = 0; i < order.length; i++) {
      var key = order[i], v = cfg.variants[key];
      if (!v) continue;
      var rule = v.match || RULES[key];
      if (rule && rule(q, ref, ua)) return key;
    }
    return null;
  }

  function detect(cfg) {
    var SK = cfg.storageKey, XK = cfg.storageKey + '_x';

    /* tema editöründe her zaman önizleme göster */
    if (w.Shopify && w.Shopify.designMode) {
      var order = cfg.order || ['meta', 'google', 'tiktok'];
      for (var i = 0; i < order.length; i++) if (cfg.variants[order[i]]) return order[i];
    }

    try { if (sessionStorage.getItem(XK) === '1') return null; } catch (e) {}

    var fresh = compute(cfg);
    if (fresh) {
      try { sessionStorage.setItem(SK, fresh); } catch (e) {}
      return fresh;
    }
    /* parametre kayboldu ama oturum aynı: hatırla */
    try {
      var saved = sessionStorage.getItem(SK);
      if (saved && cfg.variants[saved]) return saved;
    } catch (e) {}
    return null;
  }

  /* ------------------------------------------------------------------ css */
  function buildCss(cfg) {
    var hMob = cfg.heightMobile || cfg.height, s = [];

    s.push('html.rbar-on{--rbar-h:' + cfg.height + 'px}');
    s.push('@media(max-width:699px){html.rbar-on{--rbar-h:' + hMob + 'px}}');
    if (cfg.headerSelector) s.push('html.rbar-on ' + cfg.headerSelector + '{top:var(--rbar-h)!important}');
    s.push('html.rbar-on body{padding-top:calc(' + (cfg.bodyBasePad || '0px') + ' + var(--rbar-h))!important}');
    if (cfg.extraCss) s.push(cfg.extraCss);

    s.push('.rbar{display:flex;align-items:center;position:fixed;top:0;left:0;right:0;z-index:' + (cfg.zIndex || 2147483000) + ';height:var(--rbar-h);text-decoration:none;border-bottom:2px solid transparent;font-family:inherit;box-sizing:border-box}');
    s.push('.rbar__in{display:flex;align-items:center;gap:11px;height:100%;width:100%;max-width:' + (cfg.maxWidth || 1200) + 'px;margin:0 auto;padding:0 ' + (cfg.gutter || 20) + 'px;box-sizing:border-box}');
    s.push('.rbar__logo{flex-shrink:0;display:inline-flex;align-items:center;line-height:0}');
    s.push('.rbar__copy{display:flex;flex-direction:column;gap:1px;flex:1 1 auto;min-width:0;text-align:left}');
    s.push('.rbar__t,.rbar__s{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}');
    s.push('.rbar__t{font-size:13px;font-weight:600;letter-spacing:.02em;line-height:1.25}');
    s.push('.rbar__s{font-size:11px;font-weight:500;letter-spacing:.02em;line-height:1.2}');
    s.push('.rbar__r{flex-shrink:0;margin-left:auto;padding-left:10px;display:flex;flex-direction:column;align-items:flex-end;gap:1px;text-align:right}');
    s.push('.rbar__rv{font-size:22px;font-weight:800;line-height:1.05;white-space:nowrap}');
    s.push('.rbar__rc{font-size:12px;font-weight:600;white-space:nowrap}');
    s.push('.rbar__x{flex-shrink:0;margin-left:12px;width:30px;align-self:stretch;display:flex;align-items:center;justify-content:center;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:color .15s ease}');
    s.push('@media(max-width:699px){.rbar__in{gap:9px}.rbar__logo svg{width:25px;height:25px}.rbar__t{font-size:12.5px}.rbar__s{font-size:10.5px}.rbar__rv{font-size:19px}.rbar__rc{font-size:11px}}');
    /* Dar ekranda sağdaki puan sütunu metne yer bırakmıyor: "değerlendirme"
       kelimesini gizle, yazıyı küçült, başlığı iki satıra yay. */
    s.push('@media(max-width:480px){.rbar__in{gap:8px;padding:0 12px}.rbar__t{white-space:normal;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-height:1.18;font-size:12px}.rbar__s{font-size:10px}.rbar__rv{font-size:18px}.rbar__rc{font-size:10.5px}.rbar__rsx{display:none}.rbar__r{padding-left:8px}.rbar__x{margin-left:4px;width:26px}}');
    /* Çok dar ekranda alt satırı da bırak, başlık üç satıra kadar açılsın. */
    s.push('@media(max-width:359px){.rbar__s{display:none}.rbar__t{-webkit-line-clamp:3;font-size:11.5px}.rbar__rv{font-size:17px}}');

    /* koyu tema: Instagram */
    s.push('.rbar-dark .rbar{background:#190a14;border-image:linear-gradient(90deg,#FEDA75,#FA7E1E,#D62976,#962FBF,#4F5BD5) 1}');
    s.push('.rbar-dark .rbar:active{background:#271120}');
    s.push('.rbar-dark .rbar__t,.rbar-dark .rbar__rv{color:#fff}.rbar-dark .rbar__s{color:rgba(255,255,255,.6)}');
    s.push('.rbar-dark .rbar__star{color:#FFC93C;font-weight:400}.rbar-dark .rbar__rc{color:rgba(255,255,255,.85)}');
    s.push('.rbar-dark .rbar__x{color:rgba(255,255,255,.5)}.rbar-dark .rbar__x:hover{color:#fff}');

    /* açık tema: Google */
    s.push('.rbar-light .rbar{background:#fff;border-image:linear-gradient(90deg,#4285F4,#EA4335,#FBBC05,#34A853) 1;box-shadow:0 1px 0 rgba(0,0,0,.04)}');
    s.push('.rbar-light .rbar:active{background:#f7f8fa}');
    s.push('.rbar-light .rbar__t,.rbar-light .rbar__rv{color:#1a1a1a}.rbar-light .rbar__s{color:rgba(0,0,0,.55)}');
    s.push('.rbar-light .rbar__star{color:#F5A300;font-weight:400}.rbar-light .rbar__rc{color:rgba(0,0,0,.6)}');
    s.push('.rbar-light .rbar__x{color:rgba(0,0,0,.4)}.rbar-light .rbar__x:hover{color:#000}');

    /* TikTok */
    s.push('.rbar-tiktok .rbar{background:#000;border-image:linear-gradient(90deg,#25F4EE,#FE2C55) 1}');
    s.push('.rbar-tiktok .rbar:active{background:#141414}');
    s.push('.rbar-tiktok .rbar__t,.rbar-tiktok .rbar__rv{color:#fff}.rbar-tiktok .rbar__s{color:rgba(255,255,255,.6)}');
    s.push('.rbar-tiktok .rbar__star{color:#25F4EE;font-weight:400}.rbar-tiktok .rbar__rc{color:rgba(255,255,255,.85)}');
    s.push('.rbar-tiktok .rbar__x{color:rgba(255,255,255,.5)}.rbar-tiktok .rbar__x:hover{color:#fff}');

    return s.join('');
  }

  /* ------------------------------------------------------------------ dom */
  function elx(tag, cls) { var e = d.createElement(tag); if (cls) e.className = cls; return e; }
  function txt(cls, t) { var e = elx('span', cls); e.textContent = t == null ? '' : t; return e; }
  function svgEl(cls, key) {
    var e = elx('span', cls);
    e.setAttribute('aria-hidden', 'true');
    e.innerHTML = SVG[key] || '';
    return e;
  }

  function buildBar(cfg, v) {
    var link = v.link || cfg.link,
        external = link && link.indexOf('//') > -1,
        el = elx(link ? 'a' : 'div', 'rbar'),
        subtext = v.subtext != null ? v.subtext : cfg.subtext,
        rating = v.rating || cfg.rating;

    if (link) {
      el.setAttribute('href', link);
      if (external) { el.setAttribute('target', '_blank'); el.setAttribute('rel', 'noopener nofollow'); }
    }
    el.setAttribute('role', 'note');
    el.setAttribute('aria-label', (v.text || '') + (subtext ? ' - ' + subtext : ''));

    var inner = elx('span', 'rbar__in');
    inner.appendChild(svgEl('rbar__logo', v.logo));

    var copy = elx('span', 'rbar__copy');
    copy.appendChild(txt('rbar__t', v.text));
    if (subtext) copy.appendChild(txt('rbar__s', subtext));
    inner.appendChild(copy);

    if (rating && rating.value) {
      var r = elx('span', 'rbar__r'),
          rv = elx('span', 'rbar__rv'),
          star = elx('b', 'rbar__star');
      star.textContent = '★';
      rv.appendChild(star);
      rv.appendChild(d.createTextNode(' ' + rating.value));
      r.appendChild(rv);
      if (rating.count) {
        var rc = txt('rbar__rc', rating.count);
        if (rating.suffix) rc.appendChild(txt('rbar__rsx', ' ' + rating.suffix));
        r.appendChild(rc);
      }
      inner.appendChild(r);
    }

    if (cfg.closeable) {
      var x = svgEl('rbar__x', 'close');
      x.setAttribute('data-rbar-close', '');
      x.setAttribute('role', 'button');
      x.setAttribute('tabindex', '0');
      x.setAttribute('aria-label', 'Kapat');
      inner.appendChild(x);
    }

    el.appendChild(inner);
    return el;
  }

  function ready(fn) {
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function teardown(cfg) {
    try { sessionStorage.setItem(cfg.storageKey + '_x', '1'); } catch (e) {}
    var de = d.documentElement;
    de.className = de.className.replace(/\s*\brbar-(on|dark|light|tiktok)\b/g, '');
    var bar = d.querySelector('.rbar');
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
  }

  /* ----------------------------------------------------------------- init */
  var done = false;

  w.ReferralBar = {
    init: function (cfg) {
      if (done || !cfg || !cfg.variants) return;

      cfg.storageKey = cfg.storageKey || 'ref_bar';
      cfg.height = cfg.height || 56;
      if (typeof cfg.closeable === 'undefined') cfg.closeable = true;

      var src = detect(cfg);
      if (!src) return;
      done = true;

      var v = cfg.variants[src],
          theme = v.theme === 'light' ? 'light' : (v.theme === 'tiktok' ? 'tiktok' : 'dark'),
          st = elx('style');

      st.id = 'rbar-style';
      st.textContent = buildCss(cfg);
      (d.head || d.documentElement).appendChild(st);
      d.documentElement.className += ' rbar-on rbar-' + theme;

      ready(function () {
        if (!d.body || d.querySelector('.rbar')) return;
        d.body.insertBefore(buildBar(cfg, v), d.body.firstChild);
      });

      d.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-rbar-close]') : null;
        if (!b) return;
        e.preventDefault();
        e.stopPropagation();
        teardown(cfg);
      }, true);
    }
  };
})(window, document);
